import { Grid, Stack } from '@mui/material'
import { DateRange } from '@mui/x-date-pickers-pro'
import { format } from 'date-fns'
import { useState } from 'react'
import { showErrorMessage, showSuccessMessage } from '../../../../redux/reducers/snackbarReducer'
import { useAppDispatch } from '../../../../redux/store'
import { manualRequestsService } from '../../../../services/myActionsService'
import Button from '../../../../shared/UI/Button'
import DateRangePicker, { DateRangeValidationError } from '../../../../shared/UI/DateRangePickerV2'
import { AbsenceSickNotePutRequest } from '../../../../types/absence-sick-note'
import { BaseResponse } from '../../../../types/base-response'
import UserErrorMessage from '../../../../utils/errorFilter'
import { DateRangeType } from '../../types'

interface Props extends DateRangeType {
  absenceId: number
  onClose: () => void
  onCancel: (e: any) => void
}

function AddSickNote({
  absenceId,
  dateFrom = new Date(),
  dateTo = new Date(),
  onClose,
  onCancel,
}: Props) {
  const [dateRange, setDateRange] = useState<DateRange<Date>>([new Date(dateFrom), new Date(dateTo)])
  const [dateRangeError, setDateRangeError] = useState<DateRangeValidationError>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const dispatch = useAppDispatch()

  const handleSickNote = () => {
    if (!dateRange[0] || !dateRange[1]) {
      return
    }

    const body: AbsenceSickNotePutRequest = {
      absenceId,
      dateFrom: format(dateRange[0], `yyyy-MM-dd`),
      dateTo: format(dateRange[1], `yyyy-MM-dd`),
    }

    setIsLoading(true)
    manualRequestsService
      .addSickNote(body)
      .then(result => {
        dispatch(showSuccessMessage('Sicknote has been successfully updated'))
        onClose()
      })
      .catch(err => {
        const response: BaseResponse = err.response.data
        response.errors.forEach(error => {
          dispatch(showErrorMessage(<UserErrorMessage name={error.name} />))
        })
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Grid container xl={12} rowSpacing={4} pr={4}>
      <Grid item sm={12}>
        <DateRangePicker
          value={dateRange}
          required
          onError={setDateRangeError}
          onChange={setDateRange}
          arrange="Horizontal"
        />
      </Grid>
      <Grid item sm={12}>
        <Stack direction="row" gap={4} justifyContent="flex-end">
          <Button label="Cancel" color="secondary" variant="outlined" onClick={onCancel} />
          <Button label="Submit" loading={isLoading} disabled={dateRangeError !== null && (!!dateRangeError[0] || !!dateRangeError[1])} onClick={handleSickNote} />
        </Stack>
      </Grid>
    </Grid>
  )
}

export default AddSickNote
